module.exports = __webpack_public_path__ + "img/IMG_8997.f8a783c7.jpg";